import { DnmRoleMappingsService } from "~/entity/DnmRoleMappings/api/service";

export const useDnmRoleMappings = () => {
  const getRoleMappings = DnmRoleMappingsService.GET.getRoleMappings;
  const saveRoleMappings = DnmRoleMappingsService.PUT.saveRoleMappings;
  const deleteRoleMapping = DnmRoleMappingsService.DELETE.deleteRoleMapping;

  return {
    getRoleMappings,
    saveRoleMappings,
    deleteRoleMapping,
  };
};
